import { get, destroy, upload, uploadPut } from 'utils/fetchRequest';

/**
 * @param {string} [type] - 'railway' | 'road' | 'power_line' | 'township'
 */
export const getInfrastructure = async (type) => {
    try {
        return await get(`infrastructure${type ? `?type=${type}` : ''}`);
    } catch (err) {
        return { error: err };
    }
};

export const getInfrastructureItem = async (id) => {
    try {
        return await get(`infrastructure/${id}`);
    } catch (err) {
        return { error: err };
    }
};

export const createInfrastructure = async (formData) => {
    try {
        return await upload('infrastructure', formData);
    } catch (err) {
        return { error: err };
    }
};

export const updateInfrastructure = async (id, formData) => {
    try {
        return await uploadPut(`infrastructure/${id}`, formData);
    } catch (err) {
        return { error: err };
    }
};

export const deleteInfrastructure = async (id) => {
    try {
        return await destroy(`infrastructure/${id}`);
    } catch (err) {
        return { error: err };
    }
};
